import InspectionPanelListContainer from "./InspectionPanelList.container";
export default InspectionPanelListContainer;
